import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationExtras } from '@angular/router';
import { IAgGridEditorEvent, FxAgGridEventHandlerService } from 'app/implementation/shared/ag-grid/fx-ag-grid-event-handler.service';
import { DwModalService } from 'ng-quicksilver';
import { DwRoutingMessageService, DwNewRouteKeyService } from '@webdpt/framework';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
import { TranslateService } from '@ngx-translate/core';
import { FxModalService } from 'app/implementation/shared/components/fx-modal/fx-modal.service';
import {
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { ColumnApi, Column, RowNode, GridOptions, GridApi } from 'ag-grid-community';
import { FxUserInfoService } from 'app/implementation/auth/fx-auth/fx-user-info.service';

@Component({
  selector: 'app-fxed020-pay',
  templateUrl: './fxed020-pay.component.html',
  styleUrls: ['./fxed020-pay.component.less'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    /*
     * 注：建立新的实例，才不会造成作业间的错误
     */
    FxAgGridEventHandlerService
  ]
})

export class Fxed020PayNewComponent implements OnInit {
  @Input() selectedList: any;
  @Input() is_add: any;
  @Input() flag: any;

  cag005: string;
  [x: string]: any;
  public searchLoading: boolean; // 是否顯示加載中
  public myform: FormGroup; // 表单控件
  public master; // 单头
  public gridOptions: GridOptions;
  public infoOption = {}; // 详情显示异动资讯
  public gcaggoods: string = '';//商品编号
  private rowNodeId: string; // 记录当前编辑的行的rowNodeId

  public gcag005list = [
  ];
  public gcag005;
  public dh = 0;
  public dh2 = "";
  public pay_lists = [];
  availableFields: Array<string> = [];
  public gca001disabled = false;
  // grid ==  bgein  ==
  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  public frameworkComponents: any; // 组件渲染
  public editType = 'fullRow'; // 是否启用行修改
  public defaultColDef = {
  };
  public columnDefs = []; // 列定义
  public components = {}; // 渲染器函数
  // grid  ==  end  ==
  // grid  ===  end  ==
  public dropDownData2: any; // 单头开窗配置信息
  constructor(public route: ActivatedRoute,
    public router: DwNewRouteKeyService,
    public dwModalService: DwModalService,
    public dwMessage: DwRoutingMessageService,
    public http: FxDapHttpClient,
    private translateService: TranslateService,
    public fxModalService: FxModalService,
    public userinfo: FxUserInfoService,
    private agGridEventHandler: FxAgGridEventHandlerService
  ) { // 取得路由参数
    this.route.queryParamMap.subscribe( // 路由变化执行
      params => {
        this.gcaggoods = params.get('caggoods') || '';
        this.infoOption = {
          tableName: 'cag_f',                // 类型：String  必有字段  备注：表编号
          keyValue: {                // 类型：Object  必有字段  备注：主键信息
            caggoods: this.gcaggoods               // 类型：String  必有字段  备注：无
          }
        };
      }
    );
  }

  ngOnInit(): void {
    this.variableInit(); // 全局变量初始化
    this.gridInit(); // grid初始化
    this.onBeforeGetData();
    // if (this.gState == 'add') { // 新增状态
    //   this.stateControl();
    //   this.onAfterGetData();
    // } else {
    this.getData();
    // }
  }
  public eaatobjChange(value): void { //渠道商
    this.dropDownData2 = {
      "param": {
        'modalID': 'qry_daeaobj',     //  (必传) 开窗的编号
        'postParam': [{
          daelorg: this.userinfo.userInfo['c_org']
        }],             //  (必传) 查询参数，注意是数组
        'selected': [],
        'searchType': 'all'
      },
      "checkParam": {
        'modalID': 'qry_daeaobj',     //  (必传) 开窗的编号
        'postParam': [{
          daelorg: this.userinfo.userInfo['c_org']
        }, {
          'daeaobj': value ? value : ""
        }],             //  (必传) 查询参数，注意是数组
        'searchType': 'c'
      },
      "id": "daeaobj",
      "name": "daecust_n1"
    }
  }
  // 变量初始化
  variableInit(): void {
    // this.gdetaileditable = this.gState !== 'browse'; // 单身是否可修改
    this.dataGroup();
    this.master = {
      gca001: '',
      gcaaobj: '',
      gcaaobj_n1: '',
      gcacurr: '',
      gcaerate: '',
      availableBalance: ''
    }
    const masterConObj = {};
    Object.keys(this.master).forEach(key => {
      if (this.master[key] instanceof Array) {
        // masterConObj[key] = new FormGroup({});
      } else {
        masterConObj[key] = new FormControl(this.master[key]);
      }
    });
    this.myform = new FormGroup(masterConObj);
    console.log(this.selectedList)
    if(this.selectedList ){
      this.myform.get('gca001').setValue(Number(this.selectedList.sumPrice || 0) - Number(this.selectedList.eaa009 || 0));
    } else {
      this.myform.get('gca001').setValue(0);
    }
    this.myform.get('gcaaobj').setValue(this.userinfo.userInfo['c_cust']);
    this.myform.get('gcaaobj_n1').setValue(this.userinfo.userInfo['c_cust_n1']);
    this.is_add=true;

    // this.myform.get('gcacurr').setValue(this.selectedList.eaacurr);
    // this.myform.get('gcaerate').setValue(this.selectedList.eaaerate);
    // this.myform.get('gca001').disable();
    // }else{
    // this.myform.get('gcaaobj').setValue(this.userinfo.userInfo['c_user']);
    // this.myform.get('gcaaobj_n1').setValue(this.userinfo.userInfo['c_user_n1']);
    // }

    // this.myform.addControl('abn_f_list', new FormGroup({}));
    this.eaatobjChange("");
  }

  createDocumentFormcontrol(): void {
  }

  // grid ===  begin   ==
  // grid 初始化
  /**
   * gridInit
   */
  public gridInit(): void {

  }

  // grid多语系
  localTextFunc = (key: string): any => {// grid多语系
    return this.translateService.instant(key);
  };

  // 状态内涵外显
  public aaddtypeCellRenderer(xparam: any): any {

  }

  // grid初始化后事件
  onGridReady(params: any): void {

  }


  /**
   * 行编辑模式，在当前行进入编辑状态之前会都会执行
   * @param {JSON} params
   * @memberof FxGridComponent
   */
  onRowEditingStarted(params: any): void {
    this.rowNodeId = params.node.id; // 当前行进行编辑状态时记录rowNodeId
  }

  /**
   * 行编辑模式，退出当前行编辑状态或离开当前行时，在离开之后会执行，并且每个单元格的CellEditingStarted/CellEditingStop将被激发，此事件仅对应于整行编辑
   * @param {JSON} params
   * @memberof FxGridComponent
   */
  onRowEditingStopped(params: any): void {
    console.log('ON ROW ' + params.rowIndex + ' AFTER EDIT MODE');
  }


  selectionChanged(params: any): void {
    console.log("选择行" + this.gridApi.getSelectedRows());
    console.log("选择行", params);

  }
  public clickRowId: Number;
  onClickRow(params: any): void {
    console.log('点击行', params);
    this.clickRowId = params.rowIndex;
  }

  upRow(): void {
    if (!this.clickRowId) return;
  }
  downRow(): void {
    if (!this.clickRowId) return;
  }

  // 新增行
  addDetail(): void {
    this.gridApi.stopEditing();
    //  this.gridApi.updateRowData({ add: [new DetailObj({})] });
  }


  /**
   * 刪除明細
   *
   * @param {number} id
   *
   */
  public detailDelete(id: any): void {
    /**
     * 按 rowID 删除数据
     * 注意: 删除数据用 setRowData 和 updateRowData 都可以
     * 但 setRowData 适合在全部数据更新时使用，比较慢
     * 这里使用 updateRowData
     */
    const selectedRow = this.gridApi.getRowNode(id);
    this.gridApi.updateRowData({ remove: [selectedRow.data] });
  }

  // grid ===  end  ==
  // 获取详情数据
  getData(): void {
    this.http.post('E/ISaleService/getCustomerInfo', { param: { customer_no: this.userinfo.userInfo['c_cust'] } }).subscribe((response: any) => {
      if (response.success && response.data.availableBalance) {
        this.myform.get('availableBalance').setValue(response.data.availableBalance);
      } else {
        this.myform.get('availableBalance').setValue("");
      }
    });
    if (this.flag == 'is_add_new') {
      this.selectedList.baf_f_list.forEach(element => {
        element.checked = false;
      });
      this.pay_lists = this.selectedList.baf_f_list;
      setTimeout(() => {
        this.stateControl();
        this.onAfterGetData();
      }, 500);
    } else {
      this.http.post('B/IBCommonService/getPaymentList', {
        param: {
          // "baf003": 'Y',//是否线上支付(Y/N)
          "baw002": '5'//使用范围1-企业微信 2-公众号 3-钉钉 4-PC端 5-商城
        }
      }).subscribe(response => {
        console.log('order-list response:', response);
        response.data.forEach(element => {
          // if ('1' == this.selectedList.eaa041 ||  element.baf001 == this.selectedList.eaa053 ) {
          element.checked = false;
          this.pay_lists.push(element);
          // }
        });
        this.pay_lists = response.data;
        // this.myform.patchValue(response.data); // 更新master表单数据
        // this.master = Object.assign(new MasterObj_pay(), response.data);
        // this.master.cah_f_list = response.data.cah_f_list.map(item => new DetailObj(item));

        this.stateControl();
        this.onAfterGetData();

      });
    }
  }

  // 根据页面状态设置页面控件
  stateControl(): void {
    this.pay_lists.forEach(element => {
      if (element.baf001 == 'JH003') {
        document.getElementById('JH003').style.display = 'inline';
      } else if (element.baf001 == 'JH004') {
        document.getElementById('JH004').style.display = 'inline';
      } else {
        var div = document.createElement("div");
        div.innerHTML = `<img style="width: 3.6rem;height: 3rem;margin: -13px 0 0 -8px;"src="assets/img/home/其他支付.png" />
                        <span style="margin: 6px 0 0 6px;position: absolute">` + element.baf001_n1 + "</span>"
        div.id = element.baf001;
        div.style.cssText = "float: left;width: 163px;margin: 14px 0 0 43px;border-style: groove;padding: 16px;border-radius: 8px;height: 58px;border-color: white;border: solid 1px #d3cbcb;";
        div.addEventListener('click', (e) => this.pay_click(e))
        document.getElementById('pay_lists').appendChild(div);
      }
    });
    this.createDocumentFormcontrol();

    if (this.gridColumnApi) {
      this.gridColumnApi.setColumnVisible('operation', this.gdetaileditable); // 动态设置操作列显示隐藏
    }
    if (this.gState === 'browse') {
      Object.keys(this.myform.value).forEach(key => {
        this.myform.get(key).disable();
      });
      // 获取list值
      this.gcag005 = this.gcag005list.filter(obj => obj.value === this.myform.get('cag005').value)[0].label;

    } else if (this.gState === 'edit') {
      Object.keys(this.myform.value).forEach(key => {
        this.myform.get(key).enable();
      });
      // this.myform.get('caggoods').disable();
    } else if (this.gState === 'add') {
      Object.keys(this.myform.value).forEach(key => {
        this.myform.get(key).enable();
      });
      //this.myform.get('caggoods').disable();
      this.myform.patchValue(this.master); // 更新master表单数据
      // this.master.cah_f_list = [];
      // this.myform.get('caggoods').setValidators([]);
    }
  }

  // 新增标准字段 比如建立组织，部门等管理字段
  onClickAddStandardField(): void {
  }

  // 新增常用字段 比如单号，日期等等
  onClickAddCommonField(): void {
  }

  onBeforeGetData(): void {
    this.searchLoading = true; // 是否顯示加載中
  }

  onAfterGetData(): void {
    this.searchLoading = false; // 是否顯示加載中
  }

  // 页面开窗 ===  begin ==

  // 用户开窗


  // 页面开窗 ===   end  ==
  // 页面逻辑处理 ===  begin  ==

  //账款客户开窗
  public opengcaaobj(xEvent): void {
    const openModelParam = {
      modalID: 'qry_daeaobj',     // (必传) 开窗的编号
      postParam: [{
        daelorg: this.userinfo.userInfo['c_org']
      }],             // (必传) 查询参数，注意是数组
      selected: [],
      searchType: 'q',
      mutilSelected: false,
    };
    if (xEvent.value) {
      openModelParam.selected = (xEvent.value instanceof Array) ? xEvent.value : [xEvent.value];
    }
    this.fxModalService.searchFx(openModelParam).subscribe((data) => {
      this.myform.get('gcaaobj').setValue(data[0].daeaobj);
      this.myform.get('gcaaobj_n1').setValue(data[0].daecust_n1);
      this.myform.get('gcacurr').setValue(data[0].daecurr);
      this.myform.get('gcaerate').setValue(data[0].babtrate);
    });
  }
  public gcaaobjChange(xEvent): void {
    if (this.myform.get('gcaaobj').value === '') {    // 这边xEvent.value作为前端页面是否是空值，如果是空值，把对应的相关栏位清空
      this.myform.get('gcaaobj_n1').setValue('');
      this.myform.get('gcacurr').setValue('');
      this.myform.get('gcaerate').setValue('');
      return;
    }
    this.myform.get('gcaaobj').setValue(xEvent.id);
    this.myform.get('gcaaobj_n1').setValue(xEvent.name);
    this.myform.get('gcacurr').setValue(xEvent.daecurr);
    this.myform.get('gcaerate').setValue(xEvent.babtrate);

  }
  public pay_click(event) {
    this.pay_lists.forEach(elemt => {
      if (elemt.baf001 == event.currentTarget.id) {
        elemt.checked = true;
        event.currentTarget.style.cssText = "float: left;width: 143px;margin: 3px 0 0 43px;border-style: groove;padding: 16px;border-radius: 8px;height: 58px;border-color:red;";
        if (elemt.baf003 == "Y") {
          this.gca001disabled = false;
        } else {
          console.log(Number(this.selectedList.sumPrice || 0) - Number(this.selectedList.eaa009 || 0));
          this.myform.get('gca001').setValue(Number(this.selectedList.sumPrice || 0) - Number(this.selectedList.eaa009 || 0));
          this.gca001disabled = true;
        }
      } else {
        elemt.checked = false;
        document.getElementById(elemt.baf001).style.cssText = "float: left;width: 143px;margin: 3px 0 0 43px;border-style: groove;padding: 16px;border-radius: 8px;height: 58px;border-color:white;";
      }
    });
  }

  public changegca001(event) {
    this.isJH003 = true;
    console.log('event', event);
    var eaatamt = Number(this.selectedList.eaatamt || 0);
    var eaa009 = Number(this.selectedList.eaa009 || 0);
    var gca001 = this.myform.get('gca001').value
    if (gca001 && gca001 != '' && gca001 != null && gca001 != undefined) {
      if (Number(gca001) > (eaatamt - eaa009)) {
        this.dwMessage.errorNew(this.translateService.instant('付款金额不可大于订单未支付金额！'), "", "", "");
        this.myform.get('gca001').setValue((eaatamt - eaa009));
      }
    }
    if (gca001 === 0) {
      this.dwMessage.errorNew(this.translateService.instant('付款金额不可为0！'), "", "", "");
      this.myform.get('gca001').setValue((eaatamt - eaa009));
    }

  }

  // 页面逻辑处理 ===   end  ==

  // 功能按钮 === begin  ==
  // 回列表

  onClickCancel(): void {
    this.modal.triggerCancel();
  }

  OK(): void {
  }


  // 新增
  create(): void {
  }

  // 修改
  modify(): void {
  }

  /**
   * 取消
   */
  public cancel(): void {
  }
  // 保存
  public save(xstate: any): void {
  }

  // 保存前
  onBeforeSaveOrder(): void {
    console.log('保存前');
  }

  // 保存后
  onAfterSaveOrder(result: any, xstate: string, param: any): void {
  }



  // 重新加载页面数据
  dataGroup(): void {
  }

  // 重新加载页面数据
  dataReload(): void {
  }

  // 页面重载
  pageReload(xId: any, xState: any): void {
    const navigationExtras: NavigationExtras = {
      relativeTo: this.route, // 相對路徑導頁
      queryParams: { 'caggoods': xId, xState: xState }
    };
    this.router.navigate(['../fxed020-pay-new'], navigationExtras);
    // location.reload();//F5
  }

}
